import httpClient from "@/services/httpClient";
import { server, billing_expense } from "@/services/constants";

export const billing_expense_getdataInvoice_HBycompany_Pagination_V2 = (
  page,
  limit,
  sortBy,
  sortOrder,
  company_id,
  department_id,
  company_search,
  department_search,
  search_status,
  datefrom,
  dateto,
  search
) => {
  return httpClient.get(`${billing_expense.billing_expense_url}/${server.INVOICE_H}/getbycompany-pagination-v2`, {
    params: {
      company_id: company_id,
      department_id: department_id,
      page: page,
      limit: limit,
      sortBy: sortBy,
      sortOrder: sortOrder,
      company_search: company_search,
      department_search: department_search,
      search_status: search_status,
      datefrom: datefrom,
      dateto: dateto,
      search: search,
    },
  });
};

export const billing_expense_getPrintDataByIdAndCusTypeInvoice_H = (id, customer_type) => {
  return httpClient.get(
    `${billing_expense.billing_expense_url}/${server.INVOICE_H}` +
    `/getinvoice_h_to_print_byid_and_customer_type/${id}/${customer_type}`
  );
};

export const billing_expense_addInvoice_H = (data) => {
  return httpClient.post(`${billing_expense.billing_expense_url}/${server.INVOICE_H}` + `/`, data);
};

export const billing_expense_addInvoice_H_Geninv_id = (data) => {
  return httpClient.post(`${billing_expense.billing_expense_url}/${server.INVOICE_H}` + `/addgeninv_id`, data);
};

export const billing_expense_getdataByIdInvoice_H = (id) => {
  return httpClient.get(`${billing_expense.billing_expense_url}/${server.INVOICE_H}` + `/getbyid/${id}`);
};

export const billing_expense_addInvoice_HFile = (id, data) => {
  return httpClient.post(`${billing_expense.billing_expense_url}/${server.INVOICE_H}` + `/create_file/${id}`, data);
};

export const billing_expense_updateInvoice_H = (id, data) => {
  return httpClient.put(`${billing_expense.billing_expense_url}/${server.INVOICE_H}` + `/${id}`, data);
};

export const billing_expense_updateInvoice_H_Geninv_id = (id, data) => {
  return httpClient.put(`${billing_expense.billing_expense_url}/${server.INVOICE_H}` + `/updategeninv_id/${id}`, data);
};

export const billing_expense_deleteInvoice_H = (id) => {
  return httpClient.delete(`${billing_expense.billing_expense_url}/${server.INVOICE_H}` + `/${id}`);
};
export const billing_expense_getdataAdjustInvoice_HBycompany_Pagination_V2 = (
  page,
  limit,
  sortBy,
  sortOrder,
  company_id,
  company_search,
  department_search,
  search_status,
  datefrom,
  dateto,
  search
) => {
  return httpClient.get(`${billing_expense.billing_expense_url}/${server.INVOICE_H}` + `/getAdjustbycompanyPaginationV2`, {
    params: {
      company_id: company_id,
      page: page,
      limit: limit,
      sortBy: sortBy,
      sortOrder: sortOrder,
      company_search: company_search,
      department_search: department_search,
      search_status: search_status,
      datefrom: datefrom,
      dateto: dateto,
      search: search,
    },
  });
};


export const billing_expense_getPrintDataByIdAndCusTypeInvoice_HRC = (id, customer_type) => {
  return httpClient.get(
    `${billing_expense.billing_expense_url}/${server.INVOICE_H}` +
    `/getinvoice_h_to_print_byid_and_customer_type_rc/${id}/${customer_type}`
  );
};

export const billing_expense_getReceiveSelect_ListBycompany = (query) => {
  return httpClient.get(
    `${billing_expense.billing_expense_url}/${server.INVOICE_H}` + `/getreceiveselectlistbycompany_list`,
    query
  );
};

export const billing_expense_getReceiveDetail = (type, data) => {
  return httpClient.post(`${billing_expense.billing_expense_url}/${server.INVOICE_H}` + `/getsoreceive/${type}`, data);
};

export const billing_expense_getdataByIdInvoice_HRC = (id) => {
  return httpClient.get(`${billing_expense.billing_expense_url}/${server.INVOICE_H}` + `/getbyidrc/${id}`);
};

export const billing_expense_getcreditnote_ListBycompany = (query) => {
  return httpClient.get(
    `${billing_expense.billing_expense_url}/${server.INVOICE_H}` + `/getcreditnotebycompany_list`,
    query
  );
};


export const billing_expense_getcreditnote_ListBycompany_Pagination_V2 = (
  page,
  limit,
  sortBy,
  sortOrder,
  company_id,
  datefrom,
  dateto,
  search
) => {
  return httpClient.get(
    `${billing_expense.billing_expense_url}/${server.INVOICE_H}` + `/getcreditnotebycompany_list_pagination_v2`,
    {
      params: {
        company_id: company_id,
        page: page,
        limit: limit,
        sortBy: sortBy,
        sortOrder: sortOrder,
        datefrom: datefrom,
        dateto: dateto,
        search: search,
      },
    }
  );
};

export const billing_expense_getcreditnoteBycompany = (query) => {
  return httpClient.get(`${billing_expense.billing_expense_url}/${server.INVOICE_H}` + `/getcreditnotebycompany`, query);
};

export const billing_expense_addInvoice_HCN = (data) => {
  return httpClient.post(`${billing_expense.billing_expense_url}/${server.INVOICE_H}` + `/cn`, data);
};

export const billing_expense_addInvoice_H_Geninv_idCN = (data) => {
  return httpClient.post(`${billing_expense.billing_expense_url}/${server.INVOICE_H}` + `/addgeninv_idCN`, data);
};

export const billing_expense_getdataReportInv_Pagination = (
  user_role,
  page,
  limit,
  sortBy,
  sortOrder,
  company_id,
  datefrom,
  dateto,
  customer_id,
  company_inv,
  department,
  status
) => {
  return httpClient.get(`${billing_expense.billing_expense_url}/${server.INVOICE_H}` + `/searchinv_report_pagination`, {
    params: {
      user_role,
      page,
      limit,
      sortBy,
      sortOrder,
      company_id,
      datefrom,
      dateto,
      customer_id,
      company_inv,
      department,
      status,
    },
  });
};

export const billing_expense_getdataReportRc_Pagination = (
  page,
  limit,
  sortBy,
  sortOrder,
  company_id,
  datefrom,
  dateto,
  customer_id,
  department,
  status
) => {
  return httpClient.get(`${billing_expense.billing_expense_url}/${server.INVOICE_H}` + `/searchreceive_report_pagination`, {
    params: {
      page,
      limit,
      sortBy,
      sortOrder,
      company_id,
      datefrom,
      dateto,
      customer_id,
      department,
      status,
    },
  });
};
